export default __webpack_public_path__ + "static/media/pexels-git-stephen-gitau-1667849.526dc2a3.jpg";